import React from 'react';

import { Alert, InfoBox } from '@infoods/lifebase-ui';

import classes from './QuestionnaireAnswerOverview.module.scss';
import { AnswerInfoRow } from './AnswerInfoRow/AnswerInfoRow';

const QuestionnaireAnswerOverview = () => {
  return (
    <InfoBox title="Overview">
      <div className={classes.container}>
        <Alert severity="info" size="small">
          The data was downloaded from a questionnaire filled out by the user.
        </Alert>
        <div className={classes.answersBox}>
          <AnswerInfoRow title="Activity Index" questionType="ACTIVITY_INDEX" />
          <AnswerInfoRow title="Goal" questionType="GOAL" />
        </div>
      </div>
    </InfoBox>
  );
};

export { QuestionnaireAnswerOverview };
